// extracted by mini-css-extract-plugin
export const parallax = "homepage-parallax-module--parallax--2aDrA";
export const accent = "homepage-parallax-module--accent--3JsY5";